<template>
  <div class="action-btn font-weight-bold">
    <v-layout style="padding: 7px 0">
      <div v-if="serve && item.status == 4"  v-show="showServed" class="ml-3">
        <v-icon
          :color="color ? color : 'green'"
          @click.prevent="serveItem(item)"
          >flaticon-item-placed</v-icon
        >
      </div>

    <div v-if="item.status == 4 || item.status == 9 || item.status == 6" class="ml-3">
        <!-- <v-icon v-if="item.status <= 2" :color="color ? color : 'grey'">touch_app</v-icon> -->
        <v-icon v-if="item.status == 4" :color="color ? color: 'green'" @click.prevent="callBackItem(item, 3)">flaticon-item-prepared</v-icon>
        <v-icon v-if="item.status == 9" :color="color ? color: 'red'">flaticon-void</v-icon>
        <v-icon v-if="item.status == 6" :color="color ? color: 'orange'">flaticon-checked</v-icon>
      </div>
      <v-speed-dial
        v-else
        v-model="item.fab"
        direction="left"
        open-on-hover
        slide-y-reverse-transition
        class="item--action"
      >
      <v-btn slot="activator" v-model="item.fab" fab flat class="mr-0 ml-2 font-weight-bold">
        <v-icon v-if="item.status <= 2" :color="color ? color : 'grey'">touch_app</v-icon>
        <v-icon v-if="item.status == 4" :color="color ? color: 'success'">flaticon-item-prepared</v-icon>
        <v-icon v-if="item.status == 9" :color="color ? color: 'red'">flaticon-void</v-icon>
        <v-icon v-if="item.status == 3" :color="color ? color: 'orange'">flaticon-item-accepted</v-icon>
          <v-icon color="white">close</v-icon>
        </v-btn>
      <v-btn fab dark small class="font-weight-bold" color="green" @click.stop="act(item, 4)">
          <v-icon>flaticon-item-prepared</v-icon>
        </v-btn>
      <v-btn fab v-if="item.status != 3 && canVoidItems" dark small class="font-weight-bold" color="red" @click.stop="act(item, 9)">
          <v-icon>flaticon-void</v-icon>
        </v-btn>
      <v-btn v-if="item.status != 3" fab dark small class="font-weight-bold" color="purple" @click.stop="act(item, 3)">
          <v-icon small>flaticon-item-accepted</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-layout>
  </div>
</template>

<style scoped>
.item--action .v-btn--floating {
  height: 30px;
  width: 30px;
  margin: 0 5px;
  z-index: 2;
}
</style>

<script>
export default {
  name: "action-btn",
  props: {
    item: {
      type: Object,
      required: true
    },
    act: {
      type: Function,
      required: true
    },
    color: {
      type: String
      //   default: "pink"
    },
    serve: {
      type: Boolean,
      default: false
    },
     showServed: {
      type: Boolean
    }
  },
  methods: {
    // @todo: restrict only to call item action's
    callBackItem(item, status) {
      this.$root.$confirm
        .open("Confirm", "Are you sure to call back?", {})
        .then((confirm) => {
          if (confirm) {
            this.act(item, status, true);
          }
        });
    },
    serveItem(item, status = 6) {
      this.act(item, status, false, true);
    }
  },
  computed: {
    canVoidItems() {
      let userPrivileges = JSON.parse(localStorage.getItem("privileges"));
      let final = userPrivileges.isAdmin;
      if (!final) {
        final =
          userPrivileges.privileges &&
          userPrivileges.privileges.indexOf("FOH_KDS_VOID_ITEMS") > -1;
      }
      return final;
    }
  }
};
</script>
